import { BANK_DETAILS_DATA, BANK_DETAILS_ERROR, BANK_DETAILS_HIDE_ERROR, BANK_DETAILS_START_LOADER, BANK_DETAILS_STOP_LOADER, } from "../interface/iBankDetails";
const initialState = {
    data: {},
    errorData: { error: null, isOpen: false },
    loader: false,
};
const bankDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case BANK_DETAILS_DATA:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case BANK_DETAILS_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case BANK_DETAILS_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case BANK_DETAILS_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case BANK_DETAILS_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default bankDetailsReducer;
